import { INSERT_AND_UPDATE_PR_AGENCY_ACTION_TYPE, GET_PR_AGENCY_DETAILS_ACTION_TYPE } from "../../../../../utils/constants";

const initialState = [];

function prAgencyReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case INSERT_AND_UPDATE_PR_AGENCY_ACTION_TYPE:
            return [...state, payload];
        case GET_PR_AGENCY_DETAILS_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default prAgencyReducer;
